import { defineMessages } from 'react-intl';

/**
 * The day labels, the Studio banner after "Make it" (design release-kit t2) and the Work page
 * (owner, 2026-10-11: Work is a menu item and a page again; ids `app.sml.promote.work.page.*`).
 * The ids that only the native Work screen renders are in `src/i18n/nativeMessages.ts`.
 */
export const workPageMessages = defineMessages({
  today: { id: 'app.sml.promote.work.day.today', defaultMessage: 'Today' },
  yesterday: { id: 'app.sml.promote.work.day.yesterday', defaultMessage: 'Yesterday' },
  // The banner of the Studio after "Make it" (design t2).
  madeTitle: { id: 'app.sml.promote.work.made.title', defaultMessage: 'Making it: {name}' },
  madeKit: {
    id: 'app.sml.promote.work.made.kit',
    defaultMessage: '{count, plural, one {Making # asset} other {Making # assets}}',
  },
  madeBody: {
    id: 'app.sml.promote.work.made.body',
    defaultMessage: 'You can make something else now.',
  },
  madeLink: { id: 'app.sml.promote.work.made.seeProgress', defaultMessage: 'See the progress' },
  madeClose: { id: 'app.sml.promote.work.made.close', defaultMessage: 'Close' },
  // The Work page.
  pageSubtitle: {
    id: 'app.sml.promote.work.page.subtitle',
    defaultMessage: 'What MUSIC24 makes for you now, what failed, and what finished in the last days.',
  },
  pageOpenStudio: { id: 'app.sml.promote.work.page.openStudio', defaultMessage: 'Make in Studio' },
  // The three lists (design assets-rethink e1): the pill, and "Last 7 days" on the right of Finished.
  pageBusy: { id: 'app.sml.promote.work.page.busyTitle', defaultMessage: 'In progress' },
  pageFailed: { id: 'app.sml.promote.work.page.failedTitle', defaultMessage: 'Failed' },
  pageDone: { id: 'app.sml.promote.work.page.doneTitle', defaultMessage: 'Finished' },
  pageDoneWindow: { id: 'app.sml.promote.work.page.doneWindow', defaultMessage: 'Last {days} days' },
  // The chip of the row that the link names (design f4).
  pageFromLink: { id: 'app.sml.promote.work.page.fromLink', defaultMessage: 'From your link' },
  pageNoBusy: { id: 'app.sml.promote.work.page.noBusy', defaultMessage: 'Nothing is made now.' },
  pageEmptyTitle: { id: 'app.sml.promote.work.page.empty.title', defaultMessage: 'Nothing is being made' },
  pageEmptyBody: {
    id: 'app.sml.promote.work.page.empty.body',
    defaultMessage: 'Make an image or a video in Studio. You see its progress here.',
  },
  pageStepPercent: { id: 'app.sml.promote.work.page.stepPercent', defaultMessage: '{step} · {percent}%' },
  pageOpenKit: { id: 'app.sml.promote.work.page.openKit', defaultMessage: 'Open in the Kit tab' },
  pageOpenPosts: { id: 'app.sml.promote.work.page.openPosts', defaultMessage: 'Open in Posts' },
  pageOpenArchive: { id: 'app.sml.promote.work.page.openArchive', defaultMessage: 'Open in the archive' },
  pageNoSong: { id: 'app.sml.promote.work.page.noSong', defaultMessage: 'No song' },
  pageOneSong: { id: 'app.sml.promote.work.page.oneSong', defaultMessage: 'You see the work of {song}.' },
  pageAllSongs: { id: 'app.sml.promote.work.page.allSongs', defaultMessage: 'Show all songs' },
});
